function _assert_this_initialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _call_super(_this, derived, args) {
    derived = _get_prototype_of(derived);
    return _possible_constructor_return(_this, _is_native_reflect_construct() ? Reflect.construct(derived, args || [], _get_prototype_of(_this).constructor) : derived.apply(_this, args));
}
function _class_call_check(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _create_class(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _get_prototype_of(o) {
    _get_prototype_of = Object.setPrototypeOf ? Object.getPrototypeOf : function getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _get_prototype_of(o);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _set_prototype_of(subClass, superClass);
}
function _possible_constructor_return(self, call) {
    if (call && (_type_of(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assert_this_initialized(self);
}
function _set_prototype_of(o, p) {
    _set_prototype_of = Object.setPrototypeOf || function setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _set_prototype_of(o, p);
}
function _type_of(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
}
function _is_native_reflect_construct() {
    try {
        var result = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (_) {}
    return (_is_native_reflect_construct = function() {
        return !!result;
    })();
}
function _ts_generator(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
import { DeviceType, LifecycleEvent } from '@sky-uk-ott/client-lib-js-device';
import { ReportingAddon } from '../../reporting-addon';
import { sdkLogger } from '../../../../logger';
import { AgfNielsenBrowserSdkClient } from './agf-nielsen-browser-sdk-client';
import { InternalSessionState } from '../../../../core/session-controller/internal-session-state';
import { PlaybackType } from '../../../../core/player/playout-data';
import { AdBreakType } from '../../../adverts/common';
import { CoreVideoInternal } from '../../../../core-video-internal';
import { secondsToMs } from '../../../../utils/time-util';
import { checkIsLiveMetadata, checkIsVodMetadata } from '../../../addon-playout-data';
import { CvsdkError, ErrorSeverity } from '../../../../error';
import { safeRequestIdleCallback } from '../../../../utils/safe-request-idle-callback';
import { JsonUtils } from '../../../../utils/json-utils';
var NRS_CALL_TIMEOUT_MS = 5000;
var NRS_FETCH_TIMEOUT_MS = 5000;
var AgfNielsenBrowserSdkMetaDataReconciliationServiceRequestHeaderOptionAccept = 'application/vnd.nielsenreconciliation.v1+json';
export var AgfNielsenBrowserSdkAddon = /*#__PURE__*/ function(ReportingAddon) {
    "use strict";
    _inherits(AgfNielsenBrowserSdkAddon, ReportingAddon);
    function AgfNielsenBrowserSdkAddon(config, session, sessionItem, agfNielsenSdkInstance) {
        var isIon = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : false;
        _class_call_check(this, AgfNielsenBrowserSdkAddon);
        var _this;
        _this = _call_super(this, AgfNielsenBrowserSdkAddon), _define_property(_this, "config", void 0), _define_property(_this, "session", void 0), _define_property(_this, "sessionItem", void 0), _define_property(_this, "name", void 0), _define_property(_this, "logger", void 0), _define_property(_this, "agfNielsenBrowserSdkClient", void 0), _define_property(_this, "lastPlayheadPosition", void 0), _define_property(_this, "lastPlayheadPositionUpdateTimestampMS", void 0), _define_property(_this, "isCurrentlyInAdBreak", void 0), _define_property(_this, "previousState", void 0), _define_property(_this, "nrsMetadataCallQueued", void 0), _define_property(_this, "playoutData", void 0), _define_property(_this, "pausePlayheadPositionUpdates", void 0), _define_property(_this, "userWaiting", void 0), _define_property(_this, "preSeekState", void 0), _define_property(_this, "listenToLifecycleEvents", void 0), _define_property(_this, "notifyAppForegrounded", void 0), _define_property(_this, "notifyAppBackgrounded", void 0), _define_property(_this, "listenToPlayoutDataEvents", void 0), _this.config = config, _this.session = session, _this.sessionItem = sessionItem, _this.name = 'AgfNielsenBrowserSdk', _this.logger = sdkLogger.withContext('AgfNielsenBrowserSdkAddon'), _this.agfNielsenBrowserSdkClient = null, _this.isCurrentlyInAdBreak = false, _this.nrsMetadataCallQueued = false, _this.pausePlayheadPositionUpdates = true, _this.userWaiting = false, _this.listenToLifecycleEvents = function() {
            if (CoreVideoInternal.lifecycle) {
                CoreVideoInternal.lifecycle.on(LifecycleEvent.Resume, _this.notifyAppForegrounded);
                CoreVideoInternal.lifecycle.on(LifecycleEvent.Suspend, _this.notifyAppBackgrounded);
            }
        }, _this.notifyAppForegrounded = function() {
            var _this_agfNielsenBrowserSdkClient;
            (_this_agfNielsenBrowserSdkClient = _this.agfNielsenBrowserSdkClient) === null || _this_agfNielsenBrowserSdkClient === void 0 ? void 0 : _this_agfNielsenBrowserSdkClient.focus(Date.now());
        }, _this.notifyAppBackgrounded = function() {
            var _this_agfNielsenBrowserSdkClient;
            (_this_agfNielsenBrowserSdkClient = _this.agfNielsenBrowserSdkClient) === null || _this_agfNielsenBrowserSdkClient === void 0 ? void 0 : _this_agfNielsenBrowserSdkClient.blur(Date.now());
        }, _this.listenToPlayoutDataEvents = function() {
            _this.session.onPlayoutDataReceived(function(playoutData) {
                if (playoutData) {
                    _this.playoutData = playoutData;
                }
            });
            _this.session.onPlaybackTimelineUpdated(function(param) {
                var absolutePosition = param.absolutePosition, position = param.position, seekableRange = param.seekableRange;
                var _this_playoutData;
                if (_this.userWaiting) return;
                if (_this.isCurrentlyInAdBreak) {
                    return;
                }
                if (((_this_playoutData = _this.playoutData) === null || _this_playoutData === void 0 ? void 0 : _this_playoutData.type) === PlaybackType.Live) {
                    _this.logger.verbose("Sending linear position update for absolute position ".concat(absolutePosition, ", position ").concat(position, ", seekable range ").concat(seekableRange));
                    var linearPositionSeconds = _this.getLinearPositionSeconds(absolutePosition, position, seekableRange);
                    _this.updatePlayheadPosition(linearPositionSeconds);
                } else {
                    _this.updatePlayheadPosition(position);
                }
            });
            _this.session.onStateChanged(function(state, currentPosition) {
                if (_this.userWaiting) return;
                switch(state){
                    case InternalSessionState.PlayerLoading:
                        _this.loadMetadata();
                        break;
                    case InternalSessionState.Playing:
                        var _this_playoutData;
                        if (_this.previousState !== undefined && [
                            InternalSessionState.Playing,
                            InternalSessionState.Paused,
                            InternalSessionState.Rebuffering
                        ].includes(_this.previousState)) if (!_this.isCurrentlyInAdBreak) {
                            _this.loadMetadata();
                        } else {
                            _this.pausePlayheadPositionUpdates = false;
                        }
                        if (_this.previousState === InternalSessionState.Seeking && ((_this_playoutData = _this.playoutData) === null || _this_playoutData === void 0 ? void 0 : _this_playoutData.type) !== PlaybackType.Live && currentPosition !== undefined) _this.updatePlayheadPosition(currentPosition);
                        _this.queueNrsMetadataCall();
                        break;
                    case InternalSessionState.Rebuffering:
                    case InternalSessionState.Paused:
                        if (_this.previousState !== InternalSessionState.Seeking || ![
                            InternalSessionState.Rebuffering,
                            InternalSessionState.Paused
                        ].includes(_this.preSeekState)) {
                            var _this_agfNielsenBrowserSdkClient;
                            (_this_agfNielsenBrowserSdkClient = _this.agfNielsenBrowserSdkClient) === null || _this_agfNielsenBrowserSdkClient === void 0 ? void 0 : _this_agfNielsenBrowserSdkClient.stop(_this.lastPlayheadPosition);
                            _this.pausePlayheadPositionUpdates = true;
                        }
                        _this.queueNrsMetadataCall();
                        break;
                    case InternalSessionState.Stopped:
                        var _this_agfNielsenBrowserSdkClient1;
                        (_this_agfNielsenBrowserSdkClient1 = _this.agfNielsenBrowserSdkClient) === null || _this_agfNielsenBrowserSdkClient1 === void 0 ? void 0 : _this_agfNielsenBrowserSdkClient1.end(_this.lastPlayheadPosition);
                        break;
                    case InternalSessionState.Seeking:
                        _this.preSeekState = _this.previousState;
                        break;
                    default:
                        break;
                }
                _this.previousState = state;
            });
            _this.session.onAdBreakStarted(function(adBreak) {
                _this.isCurrentlyInAdBreak = true;
                switch(adBreak.type){
                    case AdBreakType.Preroll:
                    case AdBreakType.Midroll:
                        _this.pausePlayheadPositionUpdates = true;
                        break;
                    case AdBreakType.Postroll:
                        var _this_agfNielsenBrowserSdkClient;
                        (_this_agfNielsenBrowserSdkClient = _this.agfNielsenBrowserSdkClient) === null || _this_agfNielsenBrowserSdkClient === void 0 ? void 0 : _this_agfNielsenBrowserSdkClient.end(_this.lastPlayheadPosition);
                        _this.pausePlayheadPositionUpdates = true;
                        break;
                    default:
                        break;
                }
            });
            _this.session.onAdBreakFinished(function(_) {
                _this.isCurrentlyInAdBreak = false;
                _this.loadMetadata();
            });
            _this.session.onAdStarted(function(ad) {
                _this.loadAdMetadata(ad);
            });
            _this.session.onAdFinished(function(_) {
                var _this_agfNielsenBrowserSdkClient;
                (_this_agfNielsenBrowserSdkClient = _this.agfNielsenBrowserSdkClient) === null || _this_agfNielsenBrowserSdkClient === void 0 ? void 0 : _this_agfNielsenBrowserSdkClient.stop(_this.lastPlayheadPosition);
                _this.pausePlayheadPositionUpdates = true;
            });
            _this.session.onAdPositionChanged(function(adPosition) {
                if (_this.isCurrentlyInAdBreak) {
                    _this.updatePlayheadPosition(adPosition.adPosition);
                }
            });
            _this.session.onUserWaitStarted(function(currentPosition, absolutePosition) {
                var _this_playoutData, _this_agfNielsenBrowserSdkClient;
                _this.userWaiting = true;
                var position = ((_this_playoutData = _this.playoutData) === null || _this_playoutData === void 0 ? void 0 : _this_playoutData.type) === PlaybackType.VOD ? currentPosition : _this.getLinearPositionSeconds(absolutePosition, currentPosition, undefined);
                (_this_agfNielsenBrowserSdkClient = _this.agfNielsenBrowserSdkClient) === null || _this_agfNielsenBrowserSdkClient === void 0 ? void 0 : _this_agfNielsenBrowserSdkClient.stop(position);
                _this.pausePlayheadPositionUpdates = true;
            });
            _this.session.onUserWaitEnded(function() {
                _this.userWaiting = false;
                _this.loadMetadata();
            });
        };
        _this.listenToPlayoutDataEvents();
        _this.listenToLifecycleEvents();
        _this.logger.verbose('Addon Created');
        _this.agfNielsenBrowserSdkClient = new AgfNielsenBrowserSdkClient(agfNielsenSdkInstance, isIon);
        return _this;
    }
    _create_class(AgfNielsenBrowserSdkAddon, [
        {
            key: "destroy",
            value: function destroy() {
                this.agfNielsenBrowserSdkClient = null;
                if (CoreVideoInternal.lifecycle) {
                    CoreVideoInternal.lifecycle.off(LifecycleEvent.Resume, this.notifyAppForegrounded);
                    CoreVideoInternal.lifecycle.off(LifecycleEvent.Suspend, this.notifyAppBackgrounded);
                }
                this.logger.verbose('Addon Destroyed');
            }
        },
        {
            key: "decorateNrsRequestUrl",
            value: function decorateNrsRequestUrl() {
                return "".concat(this.config.nrsUrl, "/nrs/content/").concat(this.getAssetIdFromSession());
            }
        },
        {
            key: "buildNrsRequestOptions",
            value: function buildNrsRequestOptions(abortTimer) {
                var headers = {
                    Accept: AgfNielsenBrowserSdkMetaDataReconciliationServiceRequestHeaderOptionAccept
                };
                return {
                    headers: headers,
                    signal: abortTimer.signal
                };
            }
        },
        {
            key: "callNielsenReconciliationService",
            value: function callNielsenReconciliationService() {
                var _this = this;
                return _async_to_generator(function() {
                    var abortTimer, abortTimeout, fetchResult, nrsMetadata, error;
                    return _ts_generator(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                abortTimer = new AbortController();
                                abortTimeout = setTimeout(function() {
                                    return abortTimer.abort();
                                }, NRS_FETCH_TIMEOUT_MS);
                                return [
                                    4,
                                    fetch(_this.decorateNrsRequestUrl(), _this.buildNrsRequestOptions(abortTimer)).catch(function(error) {
                                        _this.throwNrsWarning('NRS_TIMEOUT', "Call to Nielsen Reconciliation Service timed out after ".concat(NRS_FETCH_TIMEOUT_MS / 1000, " seconds"), error);
                                    }).finally(function() {
                                        return clearTimeout(abortTimeout);
                                    })
                                ];
                            case 1:
                                fetchResult = _state.sent();
                                if (!fetchResult) {
                                    return [
                                        2
                                    ];
                                }
                                if (fetchResult.status !== 200) {
                                    _this.throwNrsWarning('NON_200_STATUS', "Received a status code of ".concat(fetchResult.status, " from Nielsen Reconciliation Service"));
                                    return [
                                        2
                                    ];
                                }
                                _state.label = 2;
                            case 2:
                                _state.trys.push([
                                    2,
                                    4,
                                    ,
                                    5
                                ]);
                                return [
                                    4,
                                    fetchResult.json()
                                ];
                            case 3:
                                nrsMetadata = _state.sent();
                                _this.logger.breadcrumb("Additional Nielsen metadata requested: ".concat(JsonUtils.stringify(nrsMetadata)));
                                _this.loadMetadata(nrsMetadata);
                                return [
                                    3,
                                    5
                                ];
                            case 4:
                                error = _state.sent();
                                _this.throwNrsWarning('NRS_RESPONSE_PARSING_ERROR', 'Error in parsing json response from Nielsen Reconciliation Service', error);
                                return [
                                    3,
                                    5
                                ];
                            case 5:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "throwNrsWarning",
            value: function throwNrsWarning(code, message, cause) {
                var cvsdkError = CvsdkError.from({
                    code: "ADDONS.AGF_NIELSEN_BROWSER_SDK.".concat(code),
                    message: message,
                    severity: ErrorSeverity.Warning,
                    cause: cause
                });
                this.session.notifyError(cvsdkError);
            }
        },
        {
            key: "queueNrsMetadataCall",
            value: function queueNrsMetadataCall() {
                var _this = this;
                var _this_playoutData;
                var playbackType = (_this_playoutData = this.playoutData) === null || _this_playoutData === void 0 ? void 0 : _this_playoutData.type;
                if (!this.nrsMetadataCallQueued && playbackType === PlaybackType.VOD && !!this.config.nrsUrl) {
                    safeRequestIdleCallback(function() {
                        _this.callNielsenReconciliationService();
                    }, NRS_CALL_TIMEOUT_MS);
                    this.nrsMetadataCallQueued = true;
                }
            }
        },
        {
            key: "getLinearPositionSeconds",
            value: function getLinearPositionSeconds(absolutePosition, position, seekableRange) {
                var utcPositionMs;
                if (absolutePosition) {
                    utcPositionMs = absolutePosition === null || absolutePosition === void 0 ? void 0 : absolutePosition.getTime();
                } else {
                    utcPositionMs = this.calculateAbsoluteLivePlayheadPosition(position, seekableRange);
                }
                return Math.floor(utcPositionMs / 1000);
            }
        },
        {
            key: "updatePlayheadPosition",
            value: function updatePlayheadPosition(position) {
                var forceUpdate = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
                if (!this.pausePlayheadPositionUpdates && (this.isNewPlayheadPosition(position) || forceUpdate) && this.hasPlayheadPositionUpdateCooldownElapsed()) {
                    var _this_agfNielsenBrowserSdkClient;
                    (_this_agfNielsenBrowserSdkClient = this.agfNielsenBrowserSdkClient) === null || _this_agfNielsenBrowserSdkClient === void 0 ? void 0 : _this_agfNielsenBrowserSdkClient.setPlayheadPosition(position);
                    this.lastPlayheadPosition = position;
                    this.lastPlayheadPositionUpdateTimestampMS = this.roundDownNowToClosestUTCSecond();
                }
            }
        },
        {
            key: "isNewPlayheadPosition",
            value: function isNewPlayheadPosition(position) {
                return this.lastPlayheadPosition === undefined || Math.floor(position) !== Math.floor(this.lastPlayheadPosition);
            }
        },
        {
            key: "hasPlayheadPositionUpdateCooldownElapsed",
            value: function hasPlayheadPositionUpdateCooldownElapsed() {
                return CoreVideoInternal.deviceType !== DeviceType.Android || this.lastPlayheadPositionUpdateTimestampMS === undefined || this.roundDownNowToClosestUTCSecond() > this.lastPlayheadPositionUpdateTimestampMS;
            }
        },
        {
            key: "roundDownNowToClosestUTCSecond",
            value: function roundDownNowToClosestUTCSecond() {
                var now = new Date();
                now.setUTCMilliseconds(0);
                return now.getTime();
            }
        },
        {
            key: "loadMetadata",
            value: function loadMetadata(nrsMetadata) {
                var _this_playoutData_custom_nativeReporting, _this_playoutData_custom, _this_playoutData, _this_agfNielsenBrowserSdkClient;
                var metadata;
                var assetMetadata = (_this_playoutData = this.playoutData) === null || _this_playoutData === void 0 ? void 0 : (_this_playoutData_custom = _this_playoutData.custom) === null || _this_playoutData_custom === void 0 ? void 0 : (_this_playoutData_custom_nativeReporting = _this_playoutData_custom.nativeReporting) === null || _this_playoutData_custom_nativeReporting === void 0 ? void 0 : _this_playoutData_custom_nativeReporting.assetMetadata;
                if (!assetMetadata) {
                    this.session.notifyError(CvsdkError.from({
                        code: 'ADDONS.AGF_NIELSEN_BROWSER_SDK.NO_METADATA',
                        message: 'No metadata present in playout data. Cannot load metadata.',
                        severity: ErrorSeverity.Warning
                    }));
                    return;
                }
                if (this.playoutData.type === PlaybackType.Live) {
                    if (!checkIsLiveMetadata(assetMetadata)) {
                        this.session.notifyError(CvsdkError.from({
                            code: 'ADDONS.AGF_NIELSEN_BROWSER_SDK.INVALID_METADATA',
                            message: 'Asset Metadata Invalid. Expected Live Metadata but no ChannelName found.',
                            severity: ErrorSeverity.Warning
                        }));
                        return;
                    }
                    metadata = this.getLiveMetadata(assetMetadata);
                } else if (this.playoutData.type === PlaybackType.VOD || this.playoutData.type === PlaybackType.Preview) {
                    if (!checkIsVodMetadata(assetMetadata)) {
                        this.session.notifyError(CvsdkError.from({
                            code: 'ADDONS.AGF_NIELSEN_BROWSER_SDK.INVALID_METADATA',
                            message: 'Asset Metadata Invalid. Expected Vod Metadata but no UUID found.',
                            severity: ErrorSeverity.Warning
                        }));
                        return;
                    }
                    metadata = this.getVodMetadata(assetMetadata);
                } else return;
                if (nrsMetadata && !this.isCurrentlyInAdBreak) {
                    var _this_agfNielsenBrowserSdkClient1;
                    (_this_agfNielsenBrowserSdkClient1 = this.agfNielsenBrowserSdkClient) === null || _this_agfNielsenBrowserSdkClient1 === void 0 ? void 0 : _this_agfNielsenBrowserSdkClient1.stop(this.lastPlayheadPosition);
                }
                (_this_agfNielsenBrowserSdkClient = this.agfNielsenBrowserSdkClient) === null || _this_agfNielsenBrowserSdkClient === void 0 ? void 0 : _this_agfNielsenBrowserSdkClient.loadMetadata(metadata, this.playoutData.type, nrsMetadata);
                if (!this.isCurrentlyInAdBreak) {
                    this.pausePlayheadPositionUpdates = false;
                }
            }
        },
        {
            key: "getLiveMetadata",
            value: function getLiveMetadata(liveMetadata) {
                var _this_playoutData_cdns_, _this_playoutData_cdns__adsUrl;
                return {
                    assetid: this.sessionItem.key,
                    channelName: liveMetadata.channelName,
                    manifestUrl: ((_this_playoutData_cdns_ = this.playoutData.cdns[0]) === null || _this_playoutData_cdns_ === void 0 ? void 0 : _this_playoutData_cdns_.url) || ((_this_playoutData_cdns__adsUrl = this.playoutData.cdns[0].adsUrl) === null || _this_playoutData_cdns__adsUrl === void 0 ? void 0 : _this_playoutData_cdns__adsUrl.substring(0, 250)) || 'UNKNOWN',
                    formatId: liveMetadata.formatId,
                    programmeBrand: liveMetadata.programmeBrand,
                    isAvailableOverLinearTv: liveMetadata.isAvailableOverLinearTv ? 'Y' : 'N'
                };
            }
        },
        {
            key: "getVodMetadata",
            value: function getVodMetadata(vodMetadata) {
                var _this_playoutData, _this_playoutData1, _this_playoutData_cdns_;
                var type = ((_this_playoutData = this.playoutData) === null || _this_playoutData === void 0 ? void 0 : _this_playoutData.type) === PlaybackType.VOD ? 'Content' : 'Trailer';
                var _vodMetadata_episodeTitle;
                var episodeTitle = (_vodMetadata_episodeTitle = vodMetadata.episodeTitle) !== null && _vodMetadata_episodeTitle !== void 0 ? _vodMetadata_episodeTitle : 'N/A';
                var _vodMetadata_seriesTitle;
                var seriesTitle = (_vodMetadata_seriesTitle = vodMetadata.seriesTitle) !== null && _vodMetadata_seriesTitle !== void 0 ? _vodMetadata_seriesTitle : 'N/A';
                var seasonNumber = vodMetadata.seasonNumber ? String(vodMetadata.seasonNumber) : 'N/A';
                var episodeNumber = vodMetadata.episodeNumber ? String(vodMetadata.episodeNumber) : 'N/A';
                var isAvailableOverLinearTv = vodMetadata.isAvailableOverLinearTv ? 'Y' : 'N';
                var programmeBrand = vodMetadata.programmeBrand;
                var publisher = vodMetadata.publisher;
                var assetTitle = ((_this_playoutData1 = this.playoutData) === null || _this_playoutData1 === void 0 ? void 0 : _this_playoutData1.type) == PlaybackType.VOD ? "".concat(seriesTitle, "|").concat(seasonNumber, "|").concat(episodeNumber, "|").concat(episodeTitle) : "Trailer|".concat(seriesTitle);
                return {
                    assetid: this.getAssetIdFromSession(),
                    assetTitle: assetTitle,
                    duration: Math.floor(this.playoutData.durationMs / 1000),
                    isAvailableOverLinearTv: isAvailableOverLinearTv,
                    manifestUrl: ((_this_playoutData_cdns_ = this.playoutData.cdns[0]) === null || _this_playoutData_cdns_ === void 0 ? void 0 : _this_playoutData_cdns_.originalUrl) || this.playoutData.cdns[0].url.substring(0, 250) || 'UNKNOWN',
                    programmeBrand: programmeBrand,
                    publisher: publisher,
                    type: type
                };
            }
        },
        {
            key: "loadAdMetadata",
            value: function loadAdMetadata(ad) {
                var _this_playoutData, _this_agfNielsenBrowserSdkClient;
                var isWeb = CoreVideoInternal.deviceType === DeviceType.Browser;
                var metadata = {
                    adType: ad.adBreakType,
                    assetId: ad.id,
                    title: ad.name,
                    duration: ad.expectedDuration,
                    playbackType: (_this_playoutData = this.playoutData) === null || _this_playoutData === void 0 ? void 0 : _this_playoutData.type,
                    isWeb: isWeb
                };
                (_this_agfNielsenBrowserSdkClient = this.agfNielsenBrowserSdkClient) === null || _this_agfNielsenBrowserSdkClient === void 0 ? void 0 : _this_agfNielsenBrowserSdkClient.loadMetadata(metadata, PlaybackType.Advert);
                this.pausePlayheadPositionUpdates = false;
            }
        },
        {
            key: "getAssetIdFromSession",
            value: function getAssetIdFromSession() {
                return 'providerVariantId' in this.sessionItem && this.sessionItem.providerVariantId ? this.sessionItem.providerVariantId : this.sessionItem.key;
            }
        },
        {
            key: "calculateAbsoluteLivePlayheadPosition",
            value: function calculateAbsoluteLivePlayheadPosition(position, seekableRange) {
                var _seekableRange_endDate;
                var currentTimeMs = Date.now();
                // https://gspcloud.atlassian.net/browse/VPTJS-11368 report currentTime for android devices.
                if (CoreVideoInternal.deviceType === DeviceType.Android) {
                    return currentTimeMs;
                }
                var distanceToLiveEdge = seekableRange && position ? secondsToMs(seekableRange.end - position) : 0;
                var liveEdgeToCurrentTimeMs = (seekableRange === null || seekableRange === void 0 ? void 0 : seekableRange.endDate) ? currentTimeMs - ((_seekableRange_endDate = seekableRange.endDate) === null || _seekableRange_endDate === void 0 ? void 0 : _seekableRange_endDate.getTime()) : 0;
                this.logger.verbose("Calculated distance to live edge: ".concat(distanceToLiveEdge, ", current time: ").concat(currentTimeMs, ", live edge to current time: ").concat(liveEdgeToCurrentTimeMs));
                return distanceToLiveEdge > 0 ? currentTimeMs - distanceToLiveEdge - liveEdgeToCurrentTimeMs : currentTimeMs - liveEdgeToCurrentTimeMs;
            }
        }
    ]);
    return AgfNielsenBrowserSdkAddon;
}(ReportingAddon);
_define_property(AgfNielsenBrowserSdkAddon, "requiresUserConsentToBeUsed", true);

//# sourceMappingURL=agf-nielsen-browser-sdk-addon.js.map